<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chimckay0007#acknow">Acknowledgments</a></p>
<p class="tocfm"><a class="xref" href="#/chimckay0008#abbrs">List of Abbreviations</a></p>
<p class="toc"><a class="xref" href="#/chimckay0009#ch00"><span class="sm">CHAPTER</span> <span class="sm">0.</span>  Introduction: “He Is Still Out There”</a></p>
<p class="toc"><a class="xref" href="#/chimckay0010#ch01"><span class="sm">CHAPTER</span> <span class="sm">1.</span>  What Came Before Zero?</a></p>
<p class="toc"><a class="xref" href="#/chimckay0011#ch02"><span class="sm">CHAPTER</span> <span class="sm">2.</span>  The Cluster Study</a></p>
<p class="toc"><a class="xref" href="#/chimckay0012#ch03"><span class="sm">CHAPTER</span> <span class="sm">3.</span>  “Humanizing This Disease”</a></p>
<p class="toc"><a class="xref" href="#/chimckay0013#ch04"><span class="sm">CHAPTER</span> <span class="sm">4.</span>  Giving a Face to the Epidemic</a></p>
<p class="toc"><a class="xref" href="#/chimckay0014#ch05"><span class="sm">CHAPTER</span> <span class="sm">5.</span>  Ghosts and Blood</a></p>
<p class="toc"><a class="xref" href="#/chimckay0015#ch06"><span class="sm">CHAPTER</span> <span class="sm">6.</span>  Locating Gaétan Dugas’s Views</a></p>
<p class="toc"><a class="xref" href="#/chimckay0016#epil">Epilogue: Zero Hour—Making Histories of the North American AIDS Epidemic</a></p>
<p class="tocbmf"><a class="xref" href="#/chimckay0017#app">Appendix: Oral History Interviews</a></p>
<p class="tocbm"><a class="xref" href="#/chimckay0018#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chimckay0019#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chimckay0020#fn_notes">Footnotes</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mckay-0006.vue?3167b9ec